// NOTE: use the same weekday mapping as moment.js uses in moment().day() for compatability with legacy code
import withOptions from 'utils/functions/withOptions.util';
import asObject from 'utils/objects/asObject.util';

const WEEKDAY = Object.freeze({
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
});

// the keys from WEEKDAY are prefixes for the salon keys that carry the opening hours info
const RE_MA = /^(mon|tue|wed|thu|fri|sat|sun)_(.*)/;

const determineOpeningHours = withOptions(({ salon }) => {
  const weekdays = [];

  for (const key of Object.keys(asObject(salon))) {
    const found = key.match(RE_MA);
    if (found) {
      const [fullKey, shortName, timeKey] = found;
      const ordinal = WEEKDAY[shortName] || 0;

      // first make sure there is an object to write to
      weekdays[ordinal] = weekdays[ordinal] || {};

      // then write out the data
      weekdays[ordinal][timeKey] = salon[fullKey];
      weekdays[ordinal].shortName = shortName;
    }
  }

  return weekdays;
});

// noinspection JSUnusedGlobalSymbols
export default determineOpeningHours;
